var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "form-settings" } }, [
    _c("div", { staticClass: "settings-menu" }, [
      _c(
        "div",
        {
          staticClass: "menu-item",
          class: { active: _vm.activeItem === 0 },
          on: {
            click: function ($event) {
              return _vm.setActive(0)
            },
          },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("settings")]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.formSettings.formSettings"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(
                _vm._s(_vm.$t("form.formSettings.changeFormStateAndProperties"))
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item",
          class: { active: _vm.activeItem === 1 },
          on: {
            click: function ($event) {
              return _vm.setActive(1)
            },
          },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [
            _vm._v("confirmation_number"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.redicetFormAnswer"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("form.redicetFormAnswerDesc2"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 2 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("mail")]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.formSettings.emails"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("form.formSettings.emailsDesc"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 3 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("account_tree")]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.formSettings.conditions"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("form.formSettings.conditionsDesc"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 4 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("thumb_up")]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.formSettings.thankYouPage"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("form.formSettings.thankYouPageDesc"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 5 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [
            _vm._v("integration_instructions"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.formSettings.integretions"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("form.formSettings.integretionsDesc"))),
            ]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm.activeItem === 0
          ? _c("FormDetail", {
              attrs: { formId: _vm.formId, siteId: _vm.siteId },
            })
          : _vm.activeItem === 1
          ? _c("FormOrientation", {
              attrs: { formId: _vm.formId, siteId: _vm.siteId },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }